import { INV_TYPE_CODE } from "../../phan-he-vien-phi/const/VienPhiConstant";

export const EXPORT_TYPE = {
    PDF: "pdf",
    DOC: "doc"
}

export const MAP_EXPORT_PATH = {
    [INV_TYPE_CODE.PHIEU_THU.code]: "phieu_thu",
    [INV_TYPE_CODE.PHIEU_TAM_UNG.code]: "tam_ung",
    [INV_TYPE_CODE.PHIEU_HOAN.code]: "phieu_hoan",
    PHIEU_CHI_DINH_KHAM_BENH: "PHIEU_CHI_DINH_KHAM_BENH",
};

export const SIGNATURE_MODULE = {
    TEST: "test",
    RISPACS: "rispacs",
    CLINICAL: "clinical",
    INPATIENT: "inpatient",
    SURGERY: "surgery",
};

export const SIGNATURE_TYPE = {
    PHIEU_KQ_CDHA: "PHIEU_KQ_CDHA",
    PHIEU_KQ_XN: "PHIEU_KQ_XN",
    HO_SO_BENH_AN: "HO_SO_BENH_AN",
    PHIEU_TH_CHUYEN_KHOA: "PHIEU_TH_CHUYEN_KHOA",
    PHIEU_DIEU_TRI: "PHIEU_DIEU_TRI",
};

export const SIGNATURE_OBJECT_TYPE = {
    RISPACS: "rispacs",
    TEST: "test",
    ORDER: "order",
    MEDICAL_RECORD: "medicalRecord",
    SURGERY: "surgery",
    TREATMENTSHEET: "treatmentSheet",
};